import { lazy, Suspense, type ComponentType } from 'react';
import { Spinner } from '@fas/ui';

/**
 * Route-level code splitting: the page module is downloaded when the route is first
 * visited, keeping the initial bundle small for faculty on mobile connections (§58.1).
 */
export function lazyPage<M extends Record<string, unknown>>(load: () => Promise<M>, name: keyof M & string): ComponentType {
  const Page = lazy(async () => ({ default: (await load())[name] as ComponentType }));
  function LazyPage() {
    return (
      <Suspense
        fallback={
          <div className="py-12">
            <Spinner label="Loading page" />
          </div>
        }
      >
        <Page />
      </Suspense>
    );
  }
  LazyPage.displayName = `Lazy(${name})`;
  return LazyPage;
}
